import styles from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueue.module.scss';
import { ListStyle, Pointer } from '@yleisradio/areena-types';
import { useCards } from 'hooks/useCards';
import { PlaceholderCard } from 'components/PlaceholderCard';
import { QueueCard } from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueueCard';
import { getCardKey } from 'utils/card';
import { AnalyticsContextProvider } from 'contexts/AnalyticsContext';

const PAGE_SIZE = 5;

type Props = {
  heading: string;
  source: Pointer;
  listKey: string;
};

const listStyle: ListStyle = {
  layout: 'vertical',
  image: '1:1',
  size: 'medium',
};

const NextInList = ({ heading, source, listKey }: Props) => {
  const { cards, loading, analyticsContext } = useCards({
    source: source,
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });

  return (
    <AnalyticsContextProvider context={analyticsContext}>
      <h3 className={styles.subTitle}>{heading}</h3>
      {cards &&
        cards.map((card) => {
          const cardKey = getCardKey(card, listKey);
          return (
            <div key={cardKey} className={styles.cardContainer}>
              <QueueCard card={card} isActive={false} cardKey={cardKey} />
            </div>
          );
        })}

      {loading &&
        Array.from({ length: PAGE_SIZE }, (_, i) => (
          <li key={i} aria-hidden>
            <PlaceholderCard listStyle={listStyle} />
          </li>
        ))}
    </AnalyticsContextProvider>
  );
};

export default NextInList;
